import styled from '@emotion/styled';
import React, { useState, useEffect, useRef, createRef } from 'react'
import { Link } from "react-router-dom";
import Konva from 'konva';
import { Stage, Layer, Circle } from 'react-konva';
import LoadingComponent from '../shared/LoadingComponent';
import DotsComponent from '../shared/DotsComponent'
import LogoDecor from '../shared/LogoComponent';

const { lerp } = require('canvas-sketch-util/math');
const random = require('canvas-sketch-util/random');

const Button = styled.button`
    padding: var(--space-16) var(--space-32);
    font-size: var(--font-14);
    white-space: nowrap;
    color: var(--color-white);
    min-width: 15rem;
    background: ${props => props.variantColor ? props.variantColor : 'gray'};
    box-shadow: ${props => props.variantShadow ? props.variantShadow : 'none'};
    border-radius: 2.75rem;
`;

const Layout = styled.div`
    display: grid;
    align-items: center;
    justify-content: center;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 25rem auto;
  
  @media only screen and (max-width: 500px){
    grid-template-columns: 0;
  }
`;

const Header = styled.h1`
    width: 22rem;
    position: relative;
    top: 6rem;
    left: 3rem;
    line-height:var(--space-54);
    margin-bottom: 1rem;

    font-size: var(--font-40);
    font-weight: 500;
    font-family:Inter,sans-serif;
    font-style:normal;
    color: var(--company);
    @media only screen and (max-width: 768px) {
        display:none;
    }
`;

const Copy = styled.p`
    margin-top: var(--space-24);
    font-size: var(--font-18);
    font-weight: 500;
    @media only screen and (max-width: 768px) {
        display:none;
    }
`;

const Graphic = styled.div`
    img {
        width: 100%;
        height:20rem;
        position: relative;
        top: 5rem;
        left: 2rem;
    }
    @media only screen and (max-width: 768px) {
        display:none;
    }
`;

const Divider = styled.div`
    height: 15rem;
    width: 1px;
    background-color: var(--color-gray-300);
    border-radius: var(--space-2);
    @media only screen and (max-width: 768px) {
        display:none;
    }
`;

const Card = styled.div`
    position:relative;
    display: grid;
    grid-auto-flow: column;
    grid-template-columns: 1fr 1px 1fr;
    align-items: center;
    grid-column-start: 1;
    grid-column-end: 3;
    height: 22rem;
    margin-bottom: 6rem;
    
    box-shadow: var(--card-shadow-large);
    /* padding: var(--space-64); */
    border-radius: var(--space-24);
    background-color: var(--color-white);


    @media only screen and (max-width: 768px) {
        display:flex;
        flex-direction:column;
        margin-bottom:0.5rem;
        height: 85%;
        box-shadow:none;
        border-radius:none;
        background-color:transparent;
        justify-content: space-between;
        grid-row-start:1;
        grid-row-end:5;
    }
`;

const CardHeader = styled.h2`
    line-height: 3.25rem;

    font-size: var(--font-24);
    font-weight: 500;
    color: var(--company-dark);
`;

const CardContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-left: var(--space-64);
    padding-right: var(--space-64);

    .landing-ellipse{
      position:absolute;
      top:-4.2rem;
      left:44.5rem;
      z-index:-1;
    }
    @media only screen and (max-width: 768px) {
        padding-bottom: 6rem;
      .landing-ellipse{
        display:none;
      }
    }
  
`;


const CardText = styled.p`
    width: 20rem;
    margin-top: var(--space-24);
    line-height:var(--space-28);
    
    margin-bottom: var(--space-40); 
    font-size: var(--font-18);
    color: var(--color-gray-700);
    font-weight: 400;
    text-align: center;
`;
export function Landing() {
    const [loading, setLoading] = useState(true);
    const [canvasWidth, setCanvasWidth] = useState(0)


    useEffect(() => {
        handleResize();

    });
    const handleResize = () => {
        console.log('resized to: ', window.innerWidth, 'x', window.innerHeight)
        setCanvasWidth(window.innerWidth);
        window.addEventListener('resize', handleResize)
    }
    useEffect(() => {
        setTimeout(() => {
            setLoading(false);
        }, 1000);
    })


    return (
        <>
            {loading ?
                <LoadingComponent />
                :
                <>
                    {canvasWidth > 768 ?
                        <LogoDecor />
                        :
                        null
                    }

                    <Layout>
                        <DotsComponent/>
                        {/* <img style={{zIndex:"-1",position:"absolute"}}src="/animation/infinity.svg"/> */}
                        <Graphic><img src="/img/landing_image.png" alt="header image" /></Graphic>


                        <Header>Medical Supplies for Every Situation</Header>
                        {/* <Copy>We've got you covered</Copy> */}

                        <Card>
                            <CardContainer>
                                {/* <img className="landing-ellipse" src="/img/landing_ellipse.svg" alt="landing ellipse"/> */}
                                <img className="landing-ellipse" src="/page-decor/large-blue-irad-symbol.svg" alt="landing ellipse"/>
                                <CardHeader>For Healthcare Professionals</CardHeader>

                                <CardText style={{ width: '18rem' }}>The Medical Supplies you need to improve patient outcomes</CardText>

                                <Link to={{
                                    pathname: '/home',
                                    state: {
                                        page: true
                                    }
                                }}><Button variantColor="var(--hero-button)" variantShadow="var(--hero-button-shadow)">Learn More</Button></Link>
                            </CardContainer>
                            <Divider />
                            <CardContainer>
                                <CardHeader>For Individuals</CardHeader>
                                <CardText >Served with just a phone number and a picture of your prescription</CardText>
                                <Link to={{
                                    pathname: '/home',
                                    state: {
                                        page: false
                                    }
                                }}><Button variantColor="var(--company)" variantShadow="var(--company-button-shadow)">Send My Prescription</Button></Link>
                            </CardContainer>
                        </Card>
                    </Layout>
                </>
            }
        </>
    )

}

export default Landing
